// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__aSfK1","btn_icon":"Button_btn_icon__M-KWQ"};